import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

function StatsHighlight() {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <section className="bg-white py-5" ref={ref}>
      <div className="container text-center">
        <h2 className="mb-5 fw-semibold">Great Research Powers upself</h2>
        <div className="row justify-content-center">
          <div className="col-sm-6 col-md-4 mb-4">
            <h1 className="display-4 fw-bold text-primary">
              {inView && <CountUp end={3866} duration={3} />}
              <span>+</span>
            </h1>
            <p className="lead">Personality Items</p>
          </div>
          <div className="col-sm-6 col-md-4 mb-4">
            <h1 className="display-4 fw-bold text-primary">
              {inView && <CountUp end={252} duration={3} />}
              <span>+</span>
            </h1>
            <p className="lead">Psychology Scale Dimensions</p>
          </div>
          <div className="col-sm-12 col-md-4 mb-4">
            <h1 className="display-4 fw-bold text-primary">
              {inView && <CountUp end={7207752} duration={4} separator="," />}
              <span>+</span>
            </h1>
            <p className="lead">Possible Trait Panels</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default StatsHighlight;
